// extracted by mini-css-extract-plugin
module.exports = {"root":"dQSKsq","avatar":"c-N6g-8","content":"TsXhnk","details":"sTIiwB","expert":"yKfUuB","logo":"c8ei_6T","subtitle":"uqh8N6","title":"cYDrde"};